import React from "react";
import { useAppContext } from "contexts"; // Adjust path if needed
import AdminTrainingPage from "./admin/AdminTrainingPage";
import UserTrainingPage from "./user/UserTrainingPage";

export default function TrainingDispatcher() {
    const { userRole } = useAppContext();

    // Based on your util/roles: 2=Admin, 3=Sys-Admin
    if (userRole === 2 || userRole === 3) {
        return <AdminTrainingPage />;
    }

    // 1=User, 4=Manager (or any other role)
    return <UserTrainingPage />;
}